import { Controller } from 'stimulus';
import toArray from '@/helpers/toArray';
import getControllerForElement from '../helpers/getControllerForElement';

class PriceToggleController extends Controller {
  onChange(event) {
    window.app.vat_included = event.currentTarget.checked;

    this.changePriceSession().then(() => {
      this.updateToggles();
      this.updatePrices();
    });
  }

  // eslint-disable-next-line class-methods-use-this
  updateToggles() {
    const toggleElements = toArray(document.querySelectorAll('[data-controller="price-toggle"]'));

    toggleElements.forEach((toggleElement) => {
      toggleElement.checked = window.app.vat_included;
    });
  }

  updatePrices() {
    const priceElements = toArray(document.querySelectorAll('[data-update-price]'));

    priceElements.forEach((priceElement) => {
      const { price, priceWithTax } = priceElement.dataset;

      priceElement.innerText = window.app.vat_included ? priceWithTax : price;
    });

    this.triggerProductDetailController();
  }

  triggerProductDetailController() {
    const controllerElements = toArray(document.querySelectorAll('[data-controller="product-detail"]'));

    controllerElements.forEach((controllerElement) => {
      getControllerForElement(this.application, controllerElement, 'product-detail')
        .then((controller) => {
          controller.updatePrices();
        });
    });
  }

  changePriceSession() {
    return $.post(this.data.get('api') || '', {
      price_vat: window.app.vat_included ? 'include' : 'exclude',
    });
  }
}

PriceToggleController.targets = [];

export default PriceToggleController;
